module.exports = __webpack_public_path__ + "static/media/program.c22b47e1.svg";